// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"18387590","446":"1ce846e8","453":"d1a0bcf1"}[chunkId] + ".chunk.js";
};